import { render, staticRenderFns } from "./EventiListComponent.vue?vue&type=template&id=2ee05c92"
import script from "./EventiListComponent.vue?vue&type=script&lang=js"
export * from "./EventiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports